import React, { useState, useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import { addBanner } from 'slice/bannerSlice';

const AddBanner = () => {
    const [formData, setFormData] = useState({
        heading: '',
        image: null,
    });
    // LOCAL flag — only true when THIS form's submit button was clicked
    const [isSubmitting, setIsSubmitting] = useState(false);

    const dispatch = useDispatch();
    const { loading, error } = useSelector((state) => state.banner);
    const navigate = useNavigate();
    const prevLoadingRef = useRef(null);

    // Detect when the saga finishes: loading flips true → false AFTER we submitted
    useEffect(() => {
        // Skip the very first render — just record the current loading value
        if (prevLoadingRef.current === null) {
            prevLoadingRef.current = loading;
            return;
        }

        const wasLoading = prevLoadingRef.current;
        prevLoadingRef.current = loading;

        // Saga just finished AND it was we who triggered it
        if (isSubmitting && wasLoading === true && loading === false) {
            setIsSubmitting(false);
            if (!error) {
                toast.success('Banner added successfully!');
                navigate('/banner');
            }
        }
    }, [loading]); // eslint-disable-line react-hooks/exhaustive-deps

    const handleChange = (e) => {
        const { name, value, type } = e.target;
        setFormData(prevState => ({
            ...prevState,
            [name]: type === 'file' ? e.target.files[0] : value,
        }));
    };

    const handleSubmit = (e) => {
        e.preventDefault();

        if (!formData.heading || !formData.image) {
            toast.error('Please fill in Banner Heading and select an Image');
            return;
        }

    const formDataToSend = {
        heading: formData.heading,
        imageFile: formData.image,  // File object
    };

        setIsSubmitting(true);
        dispatch(addBanner(formDataToSend));
    };

    return (
        <div className="container-fluid px-4 py-4">
            <div className="card shadow border-0">
                <div className="card-header bg-primary text-white py-3">
                    <h5 className="mb-0">Add New Banner</h5>
                </div>
                <div className="card-body p-4">
                    <form onSubmit={handleSubmit}>
                        <div className="mb-4">
                            <label htmlFor="bannerHeading" className="adminlables">
                                Banner Heading
                            </label>
                            <input
                                type="text"
                                id="bannerHeading"
                                name="heading"
                                value={formData.heading}
                                className="form-control"
                                placeholder="Enter main heading (e.g. Modern Architecture)"
                                onChange={handleChange}
                                required
                            />
                        </div>

                        <div className="mb-4">
                            <label htmlFor="bannerImage" className="adminlables">
                                Banner Image
                            </label>
                            <input
                                type="file"
                                id="bannerImage"
                                name="image"
                                accept="image/*"
                                className="form-control btn-block filebg"
                                onChange={handleChange}
                                required
                            />
                            <small className="text-muted">
                                Recommended: large horizontal banner image.
                            </small>
                        </div>

                        <div className="d-flex justify-content-end gap-3 mt-5">
                            <button
                                type="button"
                                className="btn btn-light px-4"
                                onClick={() => navigate('/banner')}
                                disabled={isSubmitting}
                            >
                                Cancel
                            </button>
                            <button
                                type="submit"
                                className="btn btn-primary px-5"
                                disabled={isSubmitting}
                            >
                                {isSubmitting ? (
                                    <>
                                        <span
                                            className="spinner-border spinner-border-sm me-2"
                                            role="status"
                                            aria-hidden="true"
                                        />
                                        Adding...
                                    </>
                                ) : (
                                    'Add Banner'
                                )}
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default AddBanner;
